// Lib
import { combineReducers } from 'redux-immutable';

// Reducers
import editorState from './editorStateReducer';
import savedSelection from './savedSelectionReducer';
import editorId from './editorIdReducer';
import originalEditorId from './originalEditorIdReducer';

export default combineReducers({
    editorState,
    editorId,
    originalEditorId,
    savedSelection,
});
